module.exports = __webpack_public_path__ + "img/logo-priemvuz-white-footer-eng.63c614c3.svg";